import { initWebsiteJs } from '../web/javascripts/application';
require.context('../images', true);

let waitReady = true;
document.onreadystatechange = function () {
  if (waitReady && (document.readyState === "interactive" || document.readyState === "complete")) {
    waitReady = false;
    initWebsiteJs();
  }
};

// document.addEventListener("DOMContentLoaded", function(event) {
//   // initWebsiteJs();
// })